import { Button } from '@cottage/design-system/internal-tooling/ui'

type DeleteCaseDialogProps = {
  caseName: string
  onCancel: () => void
  onConfirm: () => void
  saving?: boolean
}

export default function DeleteCaseDialog({
  caseName,
  onCancel,
  onConfirm,
  saving = false,
}: DeleteCaseDialogProps) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-case-title"
        className="relative w-full max-w-md rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="delete-case-title" className="text-sm font-semibold text-gray-900">
          Delete case?
        </h3>
        <p className="mt-3 text-sm text-gray-600">
          Permanently delete <span className="font-medium text-gray-900">{caseName}</span>? This cannot
          be undone.
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" size="md" disabled={saving} onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  )
}
